<template lang="pug">
  b-modal(
    :size="option.size || 'lg'"
    v-model="visible"
    @hide="close"
    hide-footer
  )
    template(#modal-header="{ close }")
      h5 {{ option.title || $t('confirm') }}
      img(src="@/assets/logo_popup.png" style="height: 19px")
    slot
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-header {
    background-color: #fafafa;
    h5 {
      margin: 0;
    }
  }
  em {
    font-style: normal;
  }
  .modal-body {
    padding: 30px;
  }
  .warning {
    text-align: center;
    .fa-icon,
    i,
    span {
      display: block;
      margin: 0 auto;
      color: #b20000;
    }
    span {
      font-size: 19px;
      font-weight: 500;
      color: #b20000;
      padding: 10px 0 0 0;
    }
  }
  .box {
    border: 1px solid #d2d2d2;
    margin-top: 10px;
    border-radius: 2px;
    padding: 5px 0;
  }
  .msg {
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
  }
  .select {
    text-align: center;
    padding: 10px 0;
    span {
      font-size: 18px;
      font-weight: 500;
      &::before {
        content: ",";
        margin-right: 10px;
      }
      &:first-child {
        &::before {
          content: "";
          margin: 0;
        }
      }
    }
  }
  .bottom-btns {
    padding: 20px 0;
    text-align: center;
    button {
      min-width: 90px;
    }

    button + button {
      margin-left: 10px;
    }

    .btn-secondary {
      color: #fff;
      background-color: #fff;
    }
  }
}
</style>
